/**
 * IssuesFacetsColumn — Facetten-Sidebar + Kanalregeln-Dialog-Wiring, ausgelagert
 * aus IssuesPage (100-Zeilen-Limit). P4-Task 12.
 */
import { useState } from 'react'
import type { RuleCoverageEntry } from '@/lib/api/issues-insights'
import { ChannelRulesDialog } from '@/components/v2/products/channel-rules/ChannelRulesDialog'
import { IssuesFacetSidebar } from './IssuesFacetSidebar'

interface IssuesFacetsColumnProps {
  typeCounts: Record<string, number>
  severityCounts: Record<string, number>
  activeTypes: Set<string>
  activeSeverities: Set<string>
  onToggleType: (v: string) => void
  onToggleSeverity: (v: string) => void
  coverage: RuleCoverageEntry[]
  activeChannel: string | null
  onSelectChannel: (id: string | null) => void
}

export function IssuesFacetsColumn(props: IssuesFacetsColumnProps) {
  const [rulesChannelId, setRulesChannelId] = useState<string | null>(null)

  return (
    <>
      <IssuesFacetSidebar
        typeCounts={props.typeCounts}
        severityCounts={props.severityCounts}
        activeTypes={props.activeTypes}
        activeSeverities={props.activeSeverities}
        onToggleType={props.onToggleType}
        onToggleSeverity={props.onToggleSeverity}
        coverage={props.coverage}
        activeChannel={props.activeChannel}
        onSelectChannel={props.onSelectChannel}
        onSetupRules={setRulesChannelId}
      />
      <ChannelRulesDialog
        open={rulesChannelId !== null}
        onClose={() => setRulesChannelId(null)}
        initialChannelId={rulesChannelId ?? undefined}
      />
    </>
  )
}
